const INITIAL_STATE = [];

const assignmentReducer = (state = INITIAL_STATE, action) => {
	return state;
};

export default assignmentReducer;
